module.exports = __webpack_public_path__ + "static/media/Alfalfa.595e610c.PNG";